// extracted by mini-css-extract-plugin
export default {"backImg":"WeddingWebsite_backImg__GQoHj","stepperCont":"WeddingWebsite_stepperCont__Zwr1H"};